import React from "react";
import {
  FiCheck,
  FiCreditCard,
  FiPackage,
  FiRefreshCw,
} from "react-icons/fi";
import { Link } from "react-router-dom";
import { siteConfig } from "../Datas/productData";
import "../css/returns.scss";

function Returns() {
  return (
    <main className="returns-page">
      <header className="returns-page__hero">
        <div>
          <p>Customer care</p>
          <h1>Returns, made straightforward.</h1>
          <span>
            Changed your mind? Eligible online orders can be sent back within
            the return window below.
          </span>
        </div>
        <div className="returns-page__hero-number" aria-label={`${siteConfig.shipping.returnDays} day return period`}>
          <strong>{siteConfig.shipping.returnDays}</strong>
          <span>days to return</span>
        </div>
      </header>

      <section className="returns-page__summary" aria-labelledby="return-summary-title">
        <div className="returns-page__section-head">
          <p>At a glance</p>
          <h2 id="return-summary-title">A clear route back to us.</h2>
        </div>
        <div className="returns-page__summary-grid">
          <article>
            <FiRefreshCw aria-hidden="true" />
            <h3>{siteConfig.shipping.returnDays}-day window</h3>
            <p>Start the return within {siteConfig.shipping.returnDays} days of receiving your parcel.</p>
          </article>
          <article>
            <FiPackage aria-hidden="true" />
            <h3>Original condition</h3>
            <p>Send items back unused, complete and with all original labels and accessories.</p>
          </article>
          <article>
            <FiCreditCard aria-hidden="true" />
            <h3>Original payment</h3>
            <p>Approved refunds go back to the payment method used for the order.</p>
          </article>
        </div>
      </section>

      <section className="returns-page__steps" aria-labelledby="return-steps-title">
        <div className="returns-page__section-head">
          <p>How it works</p>
          <h2 id="return-steps-title">Three simple steps.</h2>
        </div>
        <ol>
          <li>
            <span>01</span>
            <div>
              <h3>Register your return</h3>
              <p>
                Email <a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a>
                with your order number and the item you would like to return.
              </p>
            </div>
          </li>
          <li>
            <span>02</span>
            <div>
              <h3>Pack it with care</h3>
              <p>
                Place the unused product, dust bag and original labels in secure
                outer packaging. Remove or cover any old delivery label.
              </p>
            </div>
          </li>
          <li>
            <span>03</span>
            <div>
              <h3>Send and keep the receipt</h3>
              <p>
                Follow the return instructions supplied by customer care and
                retain proof of postage until your refund is complete.
              </p>
            </div>
          </li>
        </ol>
      </section>

      <section className="returns-page__details" aria-labelledby="return-details-title">
        <div>
          <p className="returns-page__eyebrow">Return condition</p>
          <h2 id="return-details-title">What makes an item eligible?</h2>
          <ul>
            <li><FiCheck aria-hidden="true" /> Unused, unworn and free from marks or odour</li>
            <li><FiCheck aria-hidden="true" /> Product labels and protective pieces still attached</li>
            <li><FiCheck aria-hidden="true" /> Dust bag, straps and included accessories returned</li>
            <li><FiCheck aria-hidden="true" /> Safely packaged to prevent damage in transit</li>
          </ul>
          <p className="returns-page__note">
            Personalised goods, gift cards and products marked as non-returnable
            cannot normally be returned unless faulty. Your statutory rights are unaffected.
          </p>
        </div>
        <div className="returns-page__refund-card">
          <p className="returns-page__eyebrow">Refund timing</p>
          <h2>What happens next?</h2>
          <p>
            Once the parcel arrives, our team checks each item. We will email you
            when the return has been accepted and the refund has been requested.
          </p>
          <dl>
            <div>
              <dt>Inspection</dt>
              <dd>Usually within 3–5 business days</dd>
            </div>
            <div>
              <dt>Refund</dt>
              <dd>Usually visible within 5–10 business days</dd>
            </div>
            <div>
              <dt>Exchange</dt>
              <dd>Return the item and place a new order</dd>
            </div>
          </dl>
        </div>
      </section>

      <section className="returns-page__faq" aria-labelledby="return-faq-title">
        <div className="returns-page__section-head">
          <p>Good to know</p>
          <h2 id="return-faq-title">Return questions.</h2>
        </div>
        <div>
          <details>
            <summary>Can I return an online order to a store?</summary>
            <p>Online returns currently follow the instructions issued by customer care so the parcel can be linked to the correct order.</p>
          </details>
          <details>
            <summary>What if my item arrived damaged?</summary>
            <p>Contact us before returning it. Include your order number and clear photographs of the item and packaging so we can help quickly.</p>
          </details>
          <details>
            <summary>Are original delivery costs refunded?</summary>
            <p>Where required by applicable cancellation law, the least expensive standard delivery charge is refunded. Additional express costs may not be refundable.</p>
          </details>
          <details>
            <summary>How do I return a gift?</summary>
            <p>Contact customer care with the order information. Refunds are normally made to the original purchaser’s payment method.</p>
          </details>
        </div>
      </section>

      <section className="returns-page__cta">
        <p>Still unsure?</p>
        <h2>We will help you find the right next step.</h2>
        <div>
          <Link to="/contact">Contact customer care</Link>
          <Link to="/shipping">Read shipping information</Link>
        </div>
      </section>
    </main>
  );
}

export default Returns;
